module.exports = __webpack_public_path__ + "img/user-logo.65687abc.png";